export const COLOR_GRAY_BANNER_BACKGROUND = "#233142";
export const NO_STRINGIFY = "NO_STRINGIFY";
export const STRINGIFY = "STRINGIFY";
export const AREA_UNIT_SQM = "SQM";
export const COLOR_BRIGHT = "#1DDBD5";


